
import { Options, Vue } from "vue-class-component";
// import { SFacebook, STwitter } from "vue-socials";

@Options({
  components: {
    // SFacebook,
    // STwitter,
  },
  data() {
    return {
      windowFeatures: {},
      shareOptions: {
        url: "",
        quote: "",
        hashtag: "",
        text: "",
        hashtags: [],
        via: "",
      },
      useNativeBehavior: false,
    };
  },
})
export default class Footer extends Vue {}
